export const FULLY_INSURED = {
  value: "FULLY_INSURED",
  key: "clients.insuranceStatus.fully",
};
export const SELF_INSURED = {
  value: "SELF_INSURED",
  key: "clients.insuranceStatus.self",
};

export default [FULLY_INSURED, SELF_INSURED];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/insuranceStatuses.js